import { useMediaQuery, useWindowSize } from "usehooks-ts";

import { DRAWER_HEIGHT } from "@constants/Drawer";

const TOP_SAFE_OFFSET_PX = 24;
export function useDrawerLimits() {
  let maxBreakHeight = 600;

  const { height: viewportHeight, width } = useWindowSize();

  const isDesktop = useMediaQuery("(min-width: 1281px)");

  if (isDesktop) {
    maxBreakHeight = 550;
  }

  if (!viewportHeight) {
    return {
      maxHeight: DRAWER_HEIGHT.DESKTOP_OPEN_PERCENT,
      minHeight: DRAWER_HEIGHT.SECONDARY_POSITION,
    };
  }

  const availableHeight = viewportHeight - TOP_SAFE_OFFSET_PX;

  const cappedHeightPx = Math.min(maxBreakHeight, availableHeight);

  let maxHeight = Math.round((cappedHeightPx / viewportHeight) * 100);

  const isNarrowMobile = width <= 480;
  if (isNarrowMobile) {
    maxHeight = Math.round(maxHeight * 1.15);
  }

  if (maxHeight > DRAWER_HEIGHT.DEFAULT_OPEN_PERCENT) {
    maxHeight = DRAWER_HEIGHT.DEFAULT_OPEN_PERCENT;
  }

  return {
    maxHeight,
    minHeight: DRAWER_HEIGHT.SECONDARY_POSITION,
  };
}
